export default "__VITE_ASSET__DlqltNut__"